import dynamic from 'next/dynamic';
import { useState } from 'react';
import { ACTIONS, EVENTS, STATUS } from 'react-joyride';
import { useAnalytics, useTourState } from '../../lib/state';
import { FakeUserMenu } from './fake-user-menu';
import {
  TourChallenges,
  TourExplore,
  TourMyCompass,
  TourMyTasks,
  TourPins,
  TourFinish
} from './tour-content';
import { Tourtip } from './tourtip';

// Next.js fix for Joyride
// https://stackoverflow.com/a/61664127/538696
const JoyrideNoSSR = dynamic(
  () => import('react-joyride'),
  { ssr: false }
)

export const Tour = () => {
  const [tourState, setTourState] = useTourState()
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const analytics = useAnalytics()

  const handleJoyrideCallback = data => {
    const { action, index, status, type } = data;

    if (type === EVENTS.STEP_AFTER && action === ACTIONS.NEXT) {
      const stepIndex = index + 1;
      if (index > 1 && index < 4 && !menuIsOpen) {
        setTourState({ ...tourState, run: false })
        setMenuIsOpen(true)
        setTimeout(() => setTourState({ run: true, stepIndex }), 250);
      } else {
        if (index > 3) setMenuIsOpen(false)
        setTourState({ ...tourState, stepIndex });
      }
    }
    else if (type === EVENTS.STEP_AFTER && action === ACTIONS.CLOSE) {
      setMenuIsOpen(false)
      setTourState({ ...tourState, run: false })
    }
    else if (type === EVENTS.TOUR_END) {
      setMenuIsOpen(false)
      setTourState({ run: false, stepIndex: 0 })
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (type === EVENTS.TOUR_START) {
      analytics('link', {
        'event_type': 'tutorial_begin',
      })
    }
    else if (type === EVENTS.TOUR_END) {
      analytics('link', {
        'event_type': 'tutorial_complete',
      })
    }

    // console.groupCollapsed(type);
    // console.log(data);
    // console.groupEnd();
  };

  const steps = [
    {
      target: '[data-tour=my-compass]',
      content: <TourMyCompass />,
      disableBeacon: true,
      placement: 'bottom' as const,
    },
    {
      target: '[data-tour=my-tasks]',
      content: <TourMyTasks />,
      placement: 'bottom' as const,
    },
    {
      target: '[data-tour=explore]',
      content: <TourExplore />,
      placement: 'bottom' as const,
    },
    {
      target: '[data-tour=my-challenges]',
      content: <TourChallenges />,
      placement: 'bottom' as const,
    },
    {
      target: '[data-tour=my-pins]',
      content: <TourPins />,
      placement: 'bottom' as const,
    },
    {
      target: 'body',
      content: <TourFinish />,
      placement: 'center' as const,
    },
  ]

  return (
    <>
      <FakeUserMenu open={menuIsOpen} />
      <JoyrideNoSSR
        disableScrollParentFix={false}
        tooltipComponent={Tourtip}
        callback={handleJoyrideCallback}
        steps={steps}
        stepIndex={tourState.stepIndex}
        run={tourState.run}
        continuous={true}
        scrollToFirstStep={true}
        showProgress={true}
        showSkipButton={true}
        styles={{
          options: {
            arrowColor: '#fff',
            beaconSize: 36,
            primaryColor: '#5282DE',
            textColor: '#1F2325',
          }
        }}
      />
    </>
  )
}
